export default __webpack_public_path__ + "static/media/icon4.230ad520.svg";